import * as yup from "yup";

const memberValidationSchema = yup.object().shape({
  firstName: yup.string().min(2).max(255).required("First name is required"),
  lastName: yup.string().min(2).max(255).required("Last name is required"),
  email: yup.string().email().required("Member email is required"),
  role: yup.number().required("Role is required"),
});

export default memberValidationSchema;
